import React, { SVGProps } from 'react';

const QuickValuationIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.99998 7.49583V6.66666"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M9.99998 12.5042V13.3333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M8.55502 11.8992C8.77086 12.2525 9.13836 12.4967 9.58336 12.4967H10H10.4959C11.1417 12.4967 11.665 11.9733 11.665 11.3275C11.665 10.7917 11.3009 10.3233 10.78 10.1942L9.22002 9.8025C8.70002 9.67167 8.33502 9.20417 8.33502 8.66917C8.33502 8.02333 8.85836 7.5 9.50419 7.5H10H10.4167C10.86 7.5 11.2275 7.74333 11.4442 8.09417"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M2.9125 11.22L3.90833 12.5233L4.12333 14.1458C4.2425 15.0458 4.95 15.7542 5.85 15.8742L7.47667 16.0917L8.77917 17.0867C9.5 17.6375 10.4992 17.6375 11.22 17.0867L12.5233 16.0908H12.5217L14.145 15.8758C15.045 15.7567 15.7533 15.0492 15.8733 14.1492L16.09 12.5225C16.09 12.5233 16.5933 11.8642 17.0858 11.22C17.6367 10.4992 17.6358 9.50001 17.0858 8.77917L16.0917 7.47584L15.8767 5.85334C15.7575 4.95334 15.05 4.24501 14.15 4.12501L12.5225 3.90834L11.22 2.91334C10.4992 2.36251 9.5 2.36251 8.77917 2.91334L7.47583 3.90834H7.4775L5.85417 4.12417C4.95417 4.24334 4.24583 4.95084 4.12583 5.85084L3.90833 7.47751C3.90833 7.47667 3.405 8.13584 2.9125 8.78001C2.3625 9.50001 2.3625 10.5 2.9125 11.22V11.22Z"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default QuickValuationIcon;
